import { FileDownloadDialog } from '~/components/Global/Dialog/FileDownloadDialog';
import { useState } from 'react';
import { TFileCatalog } from '~/store/file/file.type';
import { FileListCard } from './FileListCard';

type TProps = {
  lists: {
    [resource2: string]: {
      [resource3: string]: TFileCatalog[];
    };
  };
  resource1: string;
};

export const FileListDownloadGroup = ({ lists, resource1 }: TProps) => {
  const [labels, setLabels] = useState<string[]>([]);
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
  const [list, setList] = useState<TFileCatalog[]>([]);
  return (
    <>
      {Object.entries(lists).map(([label, content]) => (
        <FileListCard
          key={label}
          label={label}
          list={content}
          handleSingleDownload={(subLabel: string) => {
            setIsDialogOpen(true);
            setLabels([resource1, label, subLabel]);
            setList(content[subLabel]);
          }}
        />
      ))}
      <FileDownloadDialog
        list={list}
        labels={labels}
        open={isDialogOpen}
        handleClose={() => {
          setIsDialogOpen(false);
        }}
      />
    </>
  );
};
